module.exports = __webpack_public_path__ + "static/media/blue-arrow.542148bf.svg";